/*
 Created by qing 2020/3/2 6:50 下午
 */


//----- 表单视图类型
export const FORM_VIEW_TYPE_WRITE_FORM = 'writeForm' // 填写表单
export const FORM_VIEW_TYPE_DATA_HANDLE = 'dataHandle' // 全部数据
export const FORM_VIEW_TYPE_TRACE = 'TRACE' // 数据追踪
export const FORM_VIEW_TYPE_DATA_VIEW = 'DATA_VIEW' // 数据视图
export const FORM_VIEW_TYPE_BOARD_VIEW = 'BOARD_VIEW' // 看板视图
export const FORM_VIEW_TYPE_MAP_PATH_VIEW = 'MAP_PATH_VIEW' // 地图轨迹视图
export const FORM_VIEW_TYPE_MAP_BUBBLE_VIEW = 'MAP_BUBBLE_VIEW' // 地图气泡视图
export const FORM_VIEW_TYPE_PHOTO = 'GALLERY' // 画廊视图
export const FORM_VIEW_TYPE_BOARD_VIEW_V2 = 'BOARD_VIEW_V2' // 看板视图2

//----- app首页tab类型
export const APP_TAB_TYPE_ALL_FORM = 'allForm' // 所有表单
export const APP_TAB_TYPE_FORM_APPLY = 'formApply' // 发起表单
export const APP_TAB_TYPE_CHECK_VIEW = 'view' // 查看视图
export const APP_TAB_TYPE_DASH = 'dashboard' // 仪表盘
export const APP_TAB_TYPE_TODO = 'todoTask' // 流程待办
export const APP_TAB_TYPE_WEBVIEW = 'webView' // 打开URL

// 客户门户页面类型
export const HOME_TAB_TYPE_FORM_APPS = 'apps' // 表单详情
export const HOME_TAB_TYPE_FORM_DETAIL = 'formDetail' // 表单详情
export const HOME_TAB_TYPE_APP = 'app' // 应用
export const HOME_TAB_TYPE_DASHBOARD = 'dashboard' // 仪表盘页面
export const HOME_TAB_TYPE_FORM_APPLY = 'formApply' // 填写表单
export const HOME_TAB_TYPE_TODO_TASK = 'todoTask' // 流程待办
export const HOME_TAB_TYPE_APP_FORMS = 'appForms' // 应用表单列表
export const HOME_TAB_TYPE_MINE = 'personalCenter' // 我的页面
export const HOME_TAB_TYPE_TEMPLATE = 'template' // 模板页面
export const HOME_TAB_TYPE_VIEW = 'view' // 视图
export const HOME_TAB_TYPE_HTML = 'html' // 富文本
export const HOME_TAB_TYPE_MIX_FORM = 'mixForm' // 项目
export const HOME_TAB_TYPE_THIRD_PAGE = 'thirdPage' // 第三方页面
export const HOME_TAB_TYPE_WORKBENCH = 'workbench' // 工作台
